import type { ReactNode } from 'react';

import { Gutter } from '@crossnokaye/ux-common';

import { DeviceIcon } from '@/components/device-icon/device-icon';
import type { EquipmentBulkEditTableIconCellContent } from '@/features/equipment-browser/equipment-bulk-edit/equipment-bulk-edit.types';

interface EquipmentBulkEditTableIconCellProps {
  content: EquipmentBulkEditTableIconCellContent;
}

export const EquipmentBulkEditTableIconCell = ({
  content,
}: EquipmentBulkEditTableIconCellProps): ReactNode => {
  const { icon, deviceId, value } = content;

  return (
    <Gutter size="sm">
      <div className="flex items-center gap-2 text-foreground text-sm">
        {deviceId && icon && <DeviceIcon deviceId={deviceId} icon={icon} />}
        {value}
      </div>
    </Gutter>
  );
};
